<template>
  <div>
    <div
      class="relative flex"
      :class="[{ 'my-4': hasError && error }, wrapperClasses]"
    >
      <input
        type="checkbox"
        class="cursor-pointer rounded"
        :class="dynamicClaasses"
        :name="name"
        :id="id"
        :checked="checked"
        :disabled="disabled"
        @change="$emit('input', $event.target.checked)"
      />
      <label
        :for="id"
        class="cursor-pointer pl-3 text-1216"
        :class="labelDynamicClaasses"
      >
        {{ label }}
        <slot></slot>
      </label>
    </div>

    <slot name="errors" />

    <ErrorMessage v-if="hasError" class="pl-6">
      {{ $t(errorMsg) }}
    </ErrorMessage>
  </div>
</template>

<script>
import ErrorMessage from "@/components/Core/ErrorMessage.vue";

export default {
  name: "BaseCheckbox",
  emits: ["input"],
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: null,
    },
    anyDirty: {
      type: Boolean,
      default: true,
    },
    wrapperClasses: {
      type: String,
    },
  },
  computed: {
    labelDynamicClaasses() {
      return {
        "text-neutral-40": this.disabled,
        "text-error error-message": this.error,
        "text-primary-blue font-light": !this.error && !this.disabled,
      };
    },
    dynamicClaasses() {
      return {
        "text-error border-error error-message": this.error,
        "text-accent border-accent": !this.error && !this.disabled,
        "text-neutral-20 border-neutral-20": this.disabled,
        "bg-accent": this.checked,
      };
    },
    hasError() {
      return this.anyDirty && this.errors && this.errors?.[this.name];
    },
    errorMsg() {
      return this.errors[this.name] instanceof Array
        ? this.errors[this.name][0]
        : this.errors[this.name];
    },
  },
  components: { ErrorMessage },
};
</script>
